import {useEffect,useMemo,useState} from 'react';
import {analyze} from '../services/api';
import {dashboardCurveRange,type CurveDateRange,type DashboardCurveOffset} from '../utils/dashboardCurveRange';
import type {PdcPoint,PeakType} from '../components/charts/PdcCurveChart';

export function useDashboardCurveComparison(userId:number,start:string,end:string,peakType:PeakType,visible:boolean,workoutTypeId?:number) {
  const [enabled,onEnabledChange]=useState(false);
  const [preset,onPreset]=useState<DashboardCurveOffset|'custom'>(180);
  const [custom,setCustom]=useState<CurveDateRange|null>(null);
  const [curve,setCurve]=useState<PdcPoint[]>([]);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState(false);
  const [retry,setRetry]=useState(0);
  const range=useMemo(()=>preset==='custom'&&custom?custom:dashboardCurveRange(start,end,preset==='custom'?180:preset),[start,end,preset,custom]);
  useEffect(()=>{
    let cancelled=false;
    setCurve([]);setError(false);setLoading(enabled&&visible);
    if(!enabled||!visible)return;
    analyze.getPowerDurationCurve(userId,{start_date:range.start,end_date:range.end,peak_type:peakType,workout_type_id:workoutTypeId})
      .then(response=>{if(!cancelled)setCurve((response.data.data.curve??[]).map(p=>({...p,workoutId:p.workout_id})).filter(p=>p.interval>0&&p.value>0&&Number.isFinite(p.value)).sort((a,b)=>a.interval-b.interval));})
      .catch(()=>{if(!cancelled)setError(true);})
      .finally(()=>{if(!cancelled)setLoading(false);});
    return()=>{cancelled=true;};
  },[userId,range.start,range.end,peakType,workoutTypeId,visible,enabled,retry]);
  return {curve,enabled,onEnabledChange,preset,onPreset,range,onCustom:(value:CurveDateRange)=>{setCustom(value);onPreset('custom');},loading,error,empty:!curve.length,onRetry:()=>setRetry(v=>v+1)};
}
